// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1EaDg","rightAdornment":"Header_rightAdornment__2xDMW"};